import { SideBar } from './SideBar';
if (!window.customElements.get('bt-sidebar')) {
    window.customElements.define('bt-sidebar', SideBar);
}
